<template>
    <div id="assignment" class="mb-5 container page">
        <div class="text-center" v-if="isLoading">
            <loader width="5rem"></loader>
        </div>
        <div class="row" v-else>
            <div class="col-md-3 mb-5">     
                <h1>{{assignment.title}}</h1>           
                <ul class="nav nav-pills nav-fill flex-column invisible-sm visible-md">
                    <li class="">
                        <router-link class="nav-link" tag="a" :to="{ name: 'ProfessionalAssignmentDescription' }">Opdracht</router-link>
                    </li>
                    <li class="">
                        <router-link class="nav-link" tag="a" :to="{ name: 'ProfessionalAssignmentChat' }">Berichten</router-link>
                    </li>
                    <li class="" >
                        <router-link :class="['nav-link', { 'disabled': !started } ]" tag="a" :to="{ name: 'ProfessionalAssignmentReport' }" :disabled="!started">Rapportages</router-link>
                    </li>
                    <li class="">
                        <router-link :class="['nav-link', { 'disabled': !completed } ]" tag="a" :to="{ name: 'ProfessionalAssignmentReview' }" :disabled="!completed">Review</router-link>
                    </li>
                    <li class="">
                        <router-link :class="['nav-link', { 'disabled': !completed } ]" tag="a" :to="{ name: 'ProfessionalAssignmentPayment' }" :disabled="!completed">Betaling</router-link>
                    </li>
                    <li class="mt-3" hidden>
                        <a class="nav-link btn btn-outline-azure" href="#">Opdracht Afronden</a>
                    </li>
                </ul>    
                <div class="form-group visible-sm invisible-md">
                    <label class="form-label">Menu</label>
                    <select class="form-control" @change="onRoute">
                        <option value="ProfessionalAssignmentDescription" :selected="$route.name == 'ProfessionalAssignmentDescription'">Opdracht</option>
                        <option value="ProfessionalAssignmentChat" :selected="$route.name == 'ProfessionalAssignmentChat'">Berichten</option>
                        <option value="ProfessionalAssignmentReport" :selected="$route.name == 'ProfessionalAssignmentReport'" :disabled="!started">Rapportages</option>
                        <option value="ProfessionalAssignmentReview" :selected="$route.name == 'ProfessionalAssignmentReview'" :disabled="!completed">Review</option>
                        <option value="ProfessionalAssignmentPayment" :selected="$route.name == 'ProfessionalAssignmentPayment'" :disabled="!completed">Betaling</option>
                    </select>   
                </div>         
            </div>
            <div class="col-md-9 mb-5">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>

import Loader from '@/components/Loader'
import { assignment } from '@/models/models.js'
export default 
{
    components: {
        Loader
    },
    data(){
        return {
            assignment: {},
            isLoading: true,
        }
    },
    mounted() {
        this.isLoading = true;
        this.$http.get('api/Assignments/' + this.$route.params.id).then((res) => {
            this.assignment = new assignment(res.data);
            this.isLoading = false;
        });
    },
    methods: {
        onRoute(el)
        {
            return this.$router.push({ name: el.currentTarget.value });
        }
    },
    computed: {
        started() {
            if(this.assignment.dates)
            {
                let now = new Date();
                if(this.assignment.dates.some((c) => { return new Date(c.date) < now }))
                {
                        return true;
                }
            }
            return false;
        },
        completed() {
            if(this.assignment.dates)
            {
                let now = new Date();
                if(this.assignment.dates.every((c) => { return new Date(c.date) < now }))
                {
                    return true;
                }
            }
            return false;
        }
    }
}

</script>